import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../../styles/NavBarCom.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
   faInstagram,
   faFacebookF,
   faWhatsapp,
   faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhoneFlip } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
// import EnApp from './EnVersion/EnApp';
import { Link } from "react-router-dom";
import WhatsApp from "../../assets/whatsapp.png";
import Instagram from "../../assets/instagram.png";
import { useGetSettingsQuery } from "../../redux/features/home/homeApiSlice";

function NavBarComp() {
   // ################### RTK QUERY ###################
   const { data: settings, isSuccess } = useGetSettingsQuery();
   console.log(settings);

   // ################### CONTENT ###################
   let content;
   if (isSuccess) {
      const { data: info } = settings;
      content = (
         <Row className=" align-items-center justify-content-between">
            <Col md={7} sm={4}>
               <div className="info">
                  <span className="contactUs"> تواصل معنا :</span>
                  <div className="contact">
                     <div className="phone">
                        <FontAwesomeIcon icon={faPhoneFlip} />
                        <span>{info?.the_phone} </span>
                     </div>
                     <div className="phone">
                        <FontAwesomeIcon icon={faEnvelope} />

                        <span>{info?.the_email}</span>
                     </div>
                  </div>
               </div>
            </Col>
            <Col md={5} sm={2}>
               <Row className=" align-items-center justify-content-md-end">
                  <Col className="changeLan" lg={3} sm={6} xs={5}>
                     {/* <Dropdown>
                        <Dropdown.Toggle variant="" id="dropdown-basic">
                           <img src={Earth} alt="" /> <span> العربية </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                           <Dropdown.Item href="">
                              <Link to="english">English</Link>
                           </Dropdown.Item>
                        </Dropdown.Menu>
                     </Dropdown> */}
                  </Col>
                  <Col sm={6} xs={7} className="social-media-col">
                     <ul>
                        <li>
                           <a href={info?.facebook}>
                              <FontAwesomeIcon icon={faFacebookF} />
                           </a>
                        </li>
                        <li>
                           <a href={`https://wa.me/963${info?.whatsapp}`}>
                              <img src={WhatsApp} alt="" />
                           </a>
                        </li>
                        <li>
                           <a href={info?.instagram}>
                              <img src={Instagram} alt="" />
                           </a>
                        </li>
                        <li>
                           <a href={info?.linkedin}>
                              <FontAwesomeIcon icon={faLinkedin} />
                           </a>
                        </li>
                     </ul>
                  </Col>
               </Row>
            </Col>
         </Row>
      );
   }

   // const handleFaceBookQRCode = () => {
   //    Swal.fire({
   //       imageUrl: "imgs/flowcode2.png",

   //       html:
   //          '<h2 style="color: black ">Scan It</h3> </br>' +
   //          '<a href="https://www.facebook.com/matrixerpsyria" style="color: rgb(24 220 220)" target="_blank">..Or Click Here To Visit FaceBook Directly </a>',
   //       imageHeight: 250,
   //       imageAlt: "FaceBook Matrix QRCode",
   //       confirmButtonText: "Close",
   //       //   focusConfirm: false
   //       confirmButtonColor: "#031723",
   //    });
   // };
   // const handleWhatsAppQRCode = () => {
   //    Swal.fire({
   //       imageUrl: "imgs/flowcode.png",

   //       html:
   //          '<h2 style="color: black ">Scan It</h3> </br>' +
   //          '<a href="" style="color: rgb(24 220 220)">..Or Click Here To Visit WhatsApp Directly </a>',
   //       imageHeight: 250,
   //       imageAlt: "FaceBook Matrix QRCode",
   //       confirmButtonText: "Close",

   //       confirmButtonColor: "#031723",
   //    });
   // };
   // const handleInstaQRCode = () => {
   //    Swal.fire({
   //       imageUrl: "imgs/flowcode.png",

   //       html:
   //          '<h2 style="color: black ">Scan It</h3> </br>' +
   //          '<a href="" style="color: rgb(24 220 220)">..Or Click Here To Visit Instagram Directly </a>',
   //       imageHeight: 250,
   //       imageAlt: "FaceBook Matrix QRCode",
   //       confirmButtonText: "Close",
   //       //   focusConfirm: false
   //       confirmButtonColor: "#031723",
   //    });
   // };
   // const handleLinkedInQRCode = () => {
   //    Swal.fire({
   //       imageUrl: "imgs/flowcode.png",

   //       html:
   //          '<h2 style="color: black ">Scan It</h3> </br>' +
   //          '<a href="" style="color: rgb(24 220 220)">..Or Click Here To Visit LinkedIn Directly </a>',
   //       imageHeight: 250,
   //       imageAlt: "FaceBook Matrix QRCode",
   //       confirmButtonText: "Close",
   //       //   focusConfirm: false
   //       confirmButtonColor: "#031723",
   //    });
   // };

   return (
      <>
         <div className="navbarDiv">
            <Container>{content}</Container>
         </div>
      </>
   );
}

export default NavBarComp;
